// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1OoAF","load2":"Spinner_load2__2sWg3"};